import reducer, { BiometricAuthenticationState } from './reducers';
import BiometricAuthenticationPopover from './components/BiometricAuthenticationPopover';

export default reducer;
export {
  BiometricAuthenticationPopover,
};
export type {
  BiometricAuthenticationState,
};
